"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _styledComponents = require("styled-components");

/**
 * Generates the CSS necessary to allow for text to
 * overflow on a line with elipsis. (...)
 */
var textOverflow = (0, _styledComponents.css)(["display:inline-block;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;width:calc(100% - 0px);"]);
var _default = textOverflow;
exports["default"] = _default;